import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import StageSelector from '../../../widgets/stageSelector';

export default class Header extends Component {

    render() {

        return (
            <div id="controls">
                <div className="branding raven-logo">
                    <Link to="/"></Link>
                </div>
                <div className="viewOptions">
                    <div className="row">
                        <div className="col-3" >
                            <StageSelector {...this.props} />
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
